import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { cn } from "@/lib/utils";

interface SkipButtonProps {
  href?: string;
  onClick?: () => void;
  fixed?: boolean;
  className?: string;
}

export function SkipButton({ href, onClick, fixed, className }: SkipButtonProps) {
  const baseClassName = cn(
    "relative inline-flex cursor-pointer items-center gap-1 rounded-md px-2 py-1.5 text-[13px] font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
    // An invisible overlay grows the touch target to 44px.
    "pointer-coarse:after:absolute pointer-coarse:after:inset-x-0 pointer-coarse:after:-inset-y-2",
    fixed && "fixed top-3 right-4 sm:right-6",
    className
  );

  const content = (
    <>
      Skip
      <ArrowRight className="size-3.5" />
    </>
  );

  if (href) {
    return (
      <Link to={href} className={baseClassName}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={baseClassName}>
      {content}
    </button>
  );
}
